(() => {
  const track = document.querySelector('.yv-about__gallery-track');
  if (!track) return;

  const slides = track.querySelectorAll('.yv-about__gallery-slide');
  const dots = document.querySelectorAll('.yv-about__gallery-dot');
  if (slides.length < 2 || dots.length !== slides.length) return;

  let raf = null;

  const updateActive = () => {
    raf = null;
    const trackRect = track.getBoundingClientRect();
    const center = trackRect.left + trackRect.width / 2;

    let bestIdx = 0;
    let bestDist = Infinity;
    slides.forEach((slide, i) => {
      const r = slide.getBoundingClientRect();
      const slideCenter = r.left + r.width / 2;
      const dist = Math.abs(slideCenter - center);
      if (dist < bestDist) {
        bestDist = dist;
        bestIdx = i;
      }
    });

    dots.forEach((dot, i) => dot.classList.toggle('is-active', i === bestIdx));
  };

  track.addEventListener('scroll', () => {
    if (raf) return;
    raf = requestAnimationFrame(updateActive);
  }, { passive: true });

  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      slides[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    });
  });

  updateActive();
})();
